import React, { Component } from 'react';
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { connect } from 'react-redux';
import SiteVars from '~/Classes/siteVars'
import i18n from '~/i18n';


@connect((store) => {
    return { accountMaster: store.accountMaster }
})
class StripeAddCard extends Component {
    constructor(props) {
        super(props);

        let stripe;

        this.state = {
            countries: undefined,
            name: undefined,
            country: '',
            zip: this.props.accountMaster.accountMaster.postCode || '',
            creatingCard: false,
            error: ""
        }

        this.addCard = this.addCard.bind(this);
        this.updateValue = this.updateValue.bind(this);

    }

    componentDidMount() {
        axios.get('/countries').then(res => {
            const countries = res.data.Countries
            let country = 'gb'
            if (this.props.accountMaster.accountMaster.country) {
                country = countries.find(c => c.name.toLowerCase() === this.props.accountMaster.accountMaster.country.toLowerCase())
                if (country) country = country.code
                else country = 'gb'
            }
            this.setState({ countries, country }, () => {
                this.stripe = Stripe(SiteVars.stripeKey);
                var elements = this.stripe.elements();
                this.cardNumber = elements.create('cardNumber', { classes: { base: 'form-group fakeInput mar-b0' }, placeholder: i18n.t('company:stripeCard.cardNumber') });
                this.cardNumber.mount(this.refs.cardNumber);
                this.cardExpiry = elements.create('cardExpiry', { classes: { base: 'form-group fakeInput mar-b0' }, placeholder: i18n.t('company:stripeCard.expiryDate') });
                this.cardExpiry.mount(this.refs.cardExpiry);
                this.cardCvc = elements.create('cardCvc', { classes: { base: 'form-group fakeInput mar-b0' }, placeholder: i18n.t('company:stripeCard.cvc') });
                this.cardCvc.mount(this.refs.cardCvc);
            })
        })
    }

    updateValue(event) {
        var state = this.state;
        state[event.target.name] = event.target.value;
        this.setState(state)
    }
    addCard(ev) {
        ev.preventDefault();
        this.setState({
            creatingCard: true,
            error: ""
        })
        this.stripe.createToken(this.cardNumber, { name: this.state.name, address_country: this.state.country, address_zip: this.state.zip }).then(result => {
            if (result.error) {
                return Promise.reject(result.error.message);
            } else {
                return axios.post('/accountMaster/paymentMethod/stripe', { token: result.token.id })
            }
        }).then((newCard) => {
            return axios.put('/accountMaster/paymentMethod/stripe', {
                default_source: newCard.data.source.id
            })
        }).then(() => {
            this.props.close()
        }).catch(err => {
            console.log(err);
            this.setState({
                error: err.data ? err.data.error || err.data.message || err.data : err,
                creatingCard: false
            })
        })
    }


    render() {
        if (!this.state.countries) return <LoadingIcons iconType="2" />
        return <Row>
            <Column xs={12} className="mar-b15">
                <TextInput placeholder={i18n.t('company:stripeCard.nameOnCard')} name="name" value={this.state.name} onChange={this.updateValue} className="stripe" />
            </Column>
            <Column xs={12} className="mar-b15">
                <div ref="cardNumber" id="card-number" className="txtInput"></div>
            </Column>
            <Column xs={6} className="mar-b15">
                <div ref="cardExpiry" id="card-expiry" className="txtInput"></div>
            </Column>
            <Column xs={6} className="mar-b15">
                <div ref="cardCvc" id="card-cvc" className="txtInput"></div>
            </Column>
            <Column xs={6} className="mar-b15">
                <TextInput value={this.state.zip} onChange={this.updateValue} name="zip" placeholder={this.state.country === 'GB' ? i18n.t('company:stripeCard.postCode') : i18n.t('company:stripeCard.zip')} />
            </Column>
            <Column xs={6} className="mar-b15">
                <Select style={{ paddingBottom: 6 }} data={this.state.countries.map(c => ({ label: c.name, value: c.code }))} placeholder={i18n.t('company:stripeCard.country')} value={this.state.country} onChange={this.updateValue} name="country" />
            </Column>
            <Column xs={12} sm={12} md={12} lg={12} className="mar-b15 quickFlex">
                <Button className="button-primary" text={i18n.t('company:stripeCard.addCard')} onClick={this.addCard} disabled={this.state.creatingCard} iconLeft={<Icons icon="plus" />} />
                {this.props.hasCloseButton && <Button className="mar-l10" text={i18n.t('cancel')} onClick={this.props.close} />}
            </Column>
            {this.state.error && this.state.error.length > 0 && <Column xs={12} className="mar-b15 center-xs">
                <div className="text-red">{this.state.error}</div>
            </Column>}
            <Column xs={12} className="mar-b15">
                <div className="text-center text-sml">
                    {i18n.t('company:stripeCard.securePayments')} <a href="https://stripe.com" target="_blank">Stripe</a>
                    <div>
                        <a href="https://stripe.com" target="_blank"><img src="https://cdn1.ourmailsender.com/siteContent/assets/misc/stripePartner.png" style={{ border: "0px" }} /></a>
                    </div>
                </div>
            </Column>

        </Row>
    }
}

export default StripeAddCard;
